import {Component, OnInit} from '@angular/core';
import fieldIcon from '@iconify/icons-mdi/focus-field';
import cropIcon from '@iconify/icons-mdi/sprout-outline';
import editIcon from '@iconify/icons-mdi/playlist-edit';
import drawIcon from '@iconify/icons-mdi/shape-polygon-plus';

@Component({
  selector: 'app-field-editor-map-controls',
  templateUrl: './field-editor-map-controls.component.html',
  styleUrls: ['./field-editor-map-controls.component.scss']
})
export class FieldEditorMapControlsComponent implements OnInit {
  viewModes = [
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${fieldIcon.body}</svg>`,
      text: 'Parcelle',
      mode: 'field',
      hint: 'Afficher les Parcelles'
    },
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${cropIcon.body}</svg>`,
      text: 'Culture',
      mode: 'crop',
      hint: 'Afficher les Cultures'
    },
  ];

  viewMode = 'field';


  editModes = [
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${editIcon.body}</svg>`,
      text: 'Données',
      mode: 'data',
      hint: 'Modifier les Données'
    },
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${drawIcon.body}</svg>`,
      text: 'Forme',
      mode: 'draw',
      hint: 'Modifier la Forme'
    },
  ];

  editMode = 'data';


  backButtonOptions: any;
  refreshButtonOptions: any;
  selectBoxOptions: any;
  addButtonOptions: any;
  saveButtonOptions: any;
  printButtonOptions: any;
  settingsButtonOptions: any;
  editModeOptions: any;

  constructor() {

    this.backButtonOptions = {
      type: 'back',
      onClick: () => {
      }
    };

    this.refreshButtonOptions = {
      icon: 'refresh',
      onClick: () => {
      }
    };

    this.selectBoxOptions = {
      width: 140,
      valueExpr: 'id',
      displayExpr: 'text',
      onValueChanged: (args) => {
      }
    };

    this.addButtonOptions = {
      icon: 'plus',
      onClick: () => {
      }
    };

    this.saveButtonOptions = {
      text: 'Save',
      onClick: () => {
      }
    };

    this.printButtonOptions = {
      text: 'Print',
      onClick: () => {
      }
    };

    this.settingsButtonOptions = {
      text: 'Settings',
      onClick: () => {
      }
    };

    this.editModeOptions = {
      items: this.viewModes,
      keyExpr: 'style',
      stylingMode: 'text'
    };
  }

  ngOnInit(): void {
  }


  itemClick(e) {
  }
}
